import {Component} from 'react';
import {Grid} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import FormattedDate from 'components/FormattedDate';

export default class TitleDescription extends Component {
  static propTypes = {
    className: PropTypes.string,
    titleDescription: PropTypes.shape({
      reference: PropTypes.string,
      type: PropTypes.string,
      issueDate: PropTypes.string,
      registerType: PropTypes.string,
      priorTitleReferences: PropTypes.arrayOf(PropTypes.string),
    }),
  };

  render() {
    const {className, titleDescription} = this.props;
    const classNames = ['title-description', className].join(' ').trim();
    const priorityReferences = titleDescription?.priorTitleReferences.join(', ').trim();

    return (
      <div className={classNames}>
        <Grid>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              <strong>Identifier</strong>
            </Grid.Column>
            <Grid.Column width={12} className="title-description-reference">
              {titleDescription?.reference ? titleDescription.reference : '-'}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              Date Issued
            </Grid.Column>
            <Grid.Column width={12} className="title-description-issue-date">
              {titleDescription?.issueDate ? <FormattedDate className="capital-value-date" date={titleDescription.issueDate} format="DD MMMM YYYY"/> : '-'}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              Prior
            </Grid.Column>
            <Grid.Column width={12} className="title-description-priority-references">
              {priorityReferences ? priorityReferences : '-'}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}